import mod from "-!./Account.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Account.js?vue&type=script&lang=js&external"